export default __webpack_public_path__ + "static/media/blank-avatar.13721704.png";